import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL,
 headers: {
 Authorization: `Bearer ${getToken()}`,
 "Content-Type": "application/json",
 },
});

/* ===============================
 ADMIN AGENDA APIs
================================ */

/**
 * Create a new agenda and link to a session
 * @param {{ title: string, description?: string }} data
 * @param {number} sessionId
 */
export const createAgenda = (data, sessionId) =>
 api.post(`/admin/agendas?sessionId=${sessionId}`, data);

/**
 * Get all agendas
 */
export const getAllAgendas = () => api.get("/admin/agendas");

/**
 * Get agenda by ID
 * @param {number} agendaId
 */
export const getAgendaById = (agendaId) =>
 api.get(`/admin/agendas/${agendaId}`);

/**
 * Update agenda
 * @param {number} agendaId
 * @param {{ title: string, description?: string }} data
 */
export const updateAgenda = (agendaId, data) =>
 api.put(`/admin/agendas/${agendaId}`, data);

/**
 * Delete agenda
 * @param {number} agendaId
 */
export const deleteAgenda = (agendaId) =>
 api.delete(`/admin/agendas/${agendaId}`);


/* ===============================
 AGENDA ITEMS APIs
================================ */

export const addAgendaItem = (agendaId, data) =>
 api.post(`/admin/agendas/${agendaId}/items`, data);

export const updateAgendaItem = (itemId, data) =>
 api.put(`/admin/agendas/items/${itemId}`, data);

export const deleteAgendaItem = (itemId) =>
 api.delete(`/admin/agendas/items/${itemId}`);


/* ===============================
 SESSION ↔ AGENDA APIs
================================ */

export const getAgendasBySession = (sessionId) =>
 api.get(`/admin/agendas/sessions/${sessionId}`);

export const addAgendaToSession = (sessionId, agendaId) =>
 api.post(`/admin/agendas/sessions/${sessionId}/add/${agendaId}`);

export const removeAgendaFromSession = (sessionId, agendaId) =>
 api.delete(`/admin/agendas/sessions/${sessionId}/remove/${agendaId}`);

/* ===============================
 AGENDA SECTIONS APIs
================================ */

export const getSectionsByAgenda = (agendaId) =>
 api.get(`/admin/agendas/${agendaId}/sections`);

export const createSection = (agendaId, data) =>
 api.post(`/admin/agendas/${agendaId}/sections`, data);

export const updateSection = (sectionId, data) =>
 api.put(`/admin/agendas/sections/${sectionId}`, data);

export const deleteSection = (sectionId) =>
 api.delete(`/admin/agendas/sections/${sectionId}`);

/* ===============================
 AGENDA QUESTIONS APIs
================================ */

export const getQuestionsBySection = (sectionId) =>
 api.get(`/admin/agendas/sections/${sectionId}/questions`);

export const createQuestion = (sectionId, data) =>
 api.post(`/admin/agendas/sections/${sectionId}/questions`, data);

export const updateQuestion = (questionId, data) =>
 api.put(`/admin/agendas/questions/${questionId}`, data);

export const deleteQuestion = (questionId) =>
 api.delete(`/admin/agendas/questions/${questionId}`);
